export const postRequest = () => ({
  method: "post",
  url: "api/voucher/deactivate",
  data: {},
  storeType: "",
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
});
